<div class="unauthorized-container">
  <img src="assets/images/unauthorized_dog.png" alt="sad dog" />
  <h1>Hey, sorry about this.</h1>
  <h3>Looks like your account doesn't have access to this page.</h3>
</div>
